module.exports = __webpack_public_path__ + "static/FaktPro-Medium-2bac48d97b3a5463e8fedfd312f66bfd.ttf";